<template>
  <div id="wechatMain">
    <div class="wechatHeader">
      <div class="f16">{{userData.nickname}}</div>
      <div>
        <el-popover popper-class="chekKefu" placement="bottom" width="400" trigger="click" v-model="returnShow">
          <div style="text-align:center;padding-top:30px;">
            客服姓名
            <el-select
              v-model="checkKEFU"
              placeholder="请选择"
              size="mini"
              class="checkStatusKefu"
              @change='saveVal'
              clearable
            >
              <el-option :value="item" v-for="(item,index) in keFuList" :key="index" :label="item" v-show='item!==username'>
                {{item}}
                <span class="onlineKefu">在线</span>
              </el-option>
              <!-- <el-option value='1'>客服1
                <span class='unlineKefu'>在线</span>
              </el-option>-->
            </el-select>
          </div>
          <el-button type='primary' size="small" style="float:right;margin-top:100px;"  @click="totoUserName">转接</el-button>
          <span slot="reference" @click="getOnlineList">转接</span>
        </el-popover>
        <!-- <span @click="selectStatus('1')">结束服务</span> -->
      </div>
    </div>
    <!-- 聊天对话框 -->
    <div class="content" style="overflow:auto; overflow-scrolling: touch"  v-scrolltop="scroll">
      <div v-show='userData.noMoremsg' style="text-align:center;color:#999;margin-bottom:10px;">暂无更多数据</div>
      <!-- <scroller :on-refresh="refresh" ref="myscroller"> -->
        <div style="padding-bottom:30px;clear:both"
            v-for="(item,index) in allMsg"
            :key="index">
           <div style="text-align:center;width: 100%;margin-bottom:10px;">
            {{timeDiff(index)>10?item.createtime:''}}
           </div>
          <div
            class="chatInfo"
            :class='item.type===0?"left":"right"'
          >
            <img :src="userData.headimgurl" alt class="profilePhoto" v-show="item.type===0&&item.messageid!=='system'"/>
            <img
              src="@/assets/img/other/kefu-photo.png"
              alt
              class="profilePhoto right"
              v-show="item.type===1&&item.messageid!=='system'"
            />
            <div
              v-show="item.messageid!=='system'&&item.message.indexOf('http')===-1"
              class="bubble bubbleWhite"
              :class='item.type===0?"bubbleWhite right":"bubbleBlue right"'
            >
            <span v-if='item.message.indexOf("http")===-1'>{{item.message}}</span>
            </div>
            <viewer :images="item.picArr" v-if='item.message.indexOf("http")!==-1' class='right'>
              <img :src='item.message' alt  style="width:230px;margin-left: 10px;margin-right: 10px;">
            </viewer>
          </div>
          <!-- 各种提示 -->
            <div  v-show='item.messageid==="system"' style="text-align:center;">
                <div class="chatEnd" v-show='item.messageid==="system"'>{{item.createtime}}{{item.message}}</div>
            </div>
        </div>

      <!-- </scroller> -->
    </div>
    <div class="bootomSend">
      <div class="whatTool">
        <div class="toolFix">
          <div>
            <i class="el-icon-folder-opened iconTool"></i>
            <i class="el-icon-chat-dot-square iconTool"></i>
          </div>
          <div>
            <el-select
              v-model="lineStatus"
              size="mini"
              placeholder=" "
              class="unlineSelect"
              :class="classStatus"
              @change="selectStatus"
            >
              <el-option label="在线" value="0" class="online"></el-option>
              <el-option label="离线" value="1" class="unline"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div
        id="editor"
        class="editor"
        style="height:83%;"
        ref="editor"
      ></div>
      <el-button round style="float:right;" @click="firstService()">发送</el-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";
import wangeditor from "wangeditor";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { getFullTime ,dateDiff} from "@/libs/date";
import $ from 'jquery'

export default {
  data() {
    return {
      chat: "",
      lineStatus: "离线",
      classStatus: "",
      checkKEFU: "",
      chatInfo: "",
      list: [],
      hintChat: false,
      hintContent: "",
      returnShow:false,
      serviceId:'',
      HEART_BEAT:2,//每50秒心跳一次
      timer:null,
      canHeart:true,
      editorPicRul:[],
      istype:'text',
      content:[],
      media_id:{},
      firstServiceData:null,
      saveValId:null,
    };
  },
  computed: {
    ...mapState({
      WS: state => state.websocket.WS, //websocket实例
      allMsg: state => state.websocket.allMsg,
      userOpenId: state => state.websocket.userOpenId,
      userData: state => state.websocket.userData,
      username: state => state.websocket.username,
      keFuList: state => state.websocket.keFuList,
      loadBottom: state => state.websocket.loadBottom,
      logPageNo: state => state.websocket.logPageNo,
      sNickName: state => state.websocket.sNickName,
      userList:state => state.websocket.userList,
      messageJson:state => state.websocket.messageJson,
      base_url:state => state.websocket.base_url,
    })
  },
  mounted() {
     let username=localStorage.getItem('userData')?JSON.parse(localStorage.getItem('userData')).realname:''
    //  username='BRM运营测试——勿删！！！'
    this.changeusername(username)
    this.$emit('chatListInit')
    this.wangEditor();
    if(sessionStorage.getItem("stateLine") === "0") {
      this.loginKefu()
    }
  },
  watch: {
    allMsg: {
      handler(val, oldVal) {
        if (val) {
          if (this.loadBottom) {
            this.scrollBottom();
          }
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions([
      "socketInit",
      "getOnlineList",
      "getLogList",
      'socketOpen',
      "serviceNickName",
      'readMessage',
    ]),
    ...mapMutations([
      "socketClose",
      "socketstateLine",
      "changelogPageNo",
      "socketSend",
      'updateChatList',
      'changeOpenId',
      'clearallMsg',
      'changeMess',
      'changnoMoremsg',
      'changeusername'
    ]),
    scrollBottom() {
      setTimeout(function() {
        let ele = document.getElementsByClassName("content")[0];
        //设置滚动条到最底部
        ele.scrollTop = ele.scrollHeight;
      }, 300);
    },
    scroll(){
      this.changelogPageNo();
      this.getLogList("start")
        .then(result => {
          if (result.length === 0) {
            this.changnoMoremsg(true)
          }else{
            setTimeout(function() {
                let ele = document.getElementsByClassName("content")[0];
                ele.scrollTop = 50;
              }, 300);
            }
        })
    },
    //聊天输入框
    wangEditor() {
      let that = this;
      let E = wangeditor;

      this.editor = new E("#editor");
      this.editor.customConfig.uploadImgShowBase64 = true;
      this.editor.customConfig.uploadImgServer = `/hcm/lowprice/uploadImage`; // 截图上传的地址
      this.editor.customConfig.uploadFileName = "file"; // 截图上传的参数名
      this.editor.customConfig.uploadImgMaxSize = 1 * 1024 * 1024// 将图片大小限制为 1M
      this.editor.customConfig.uploadImgTimeout = 50*1000
      this.editor.customConfig.showLinkImg = false
      this.editor.customConfig.customAlert = function (info) {
          that.$message.error(info)
      }
      this.editor.customConfig.uploadImgHooks = {
        customInsert: function(insertImg, result) {
          // 插入图片到富文本框
           if(!that.userOpenId&&that.userData.stateLine==='1'){
              this.$message.error('不能发送消息');
              return false
           }
          that.media_id[result.data.url]=result.data.media_id
          insertImg(result.data.url);
        }
      };
      //enter键发送
      let _this=this
       this.editor.customConfig.onfocus = function () {
          document.onkeydown=function(ev){
                var event=ev ||event
                if(event.keyCode==13){
                    _this.firstService()
                }
          }
    }
      this.editor.create();
      this.editorShow("你已离线，暂时不能回复消息", false, "#999");
    },
    clearChats() {
      if(this.lineStatus==='在线') this.editor.txt.clear();
    },
    editorShow(html, disabled, color) {
      document
        .getElementsByClassName("w-e-text")[0]
        .setAttribute("contenteditable", disabled);
      document.getElementsByClassName("w-e-text")[0].innerHTML = html;
      document.getElementsByClassName("w-e-text")[0].style.color = color;
    },
    onMessage(){
      this.WS.onmessage=(event)=>{
          let messageJson = eval("(" + event.data + ")");
          messageJson.type=0//0用户
          this.changeMess(messageJson)
        }
    },
    socketHeart(){
        //设置心跳
        let _this=this
        if (this.HEART_BEAT > 0) {
           this.timer = setInterval(()=>{
            _this.WS.send('ping');
            //如果已经关闭就停止
            console.log('心跳狀態'+_this.WS.readyState)
            if(_this.WS.readyState!== 1){
              _this.socketInit()
            }
          },parseInt(this.HEART_BEAT)*1000)
        }
        if(!this.canHeart){
          clearInterval(this.timer)
        }
    },
    async selectStatus(val) {
      if (val === "0") {
         let result=await fetchGet(`hcm/websocket/login/${this.username}`)
         if(result.status==='10000'){
            this.loginKefu()
            this.$emit('chatListInit')
         }else{
           this.$message.error(result.message)
         }
      } else if (val === "1") {
        if(this.userData.stateLine==='0'){
           this.lineStatus = "离线";
          this.socketClose()
          this.editorShow("你已离线，暂时不能回复消息", false, "#999");
          this.canHeart=false
          clearInterval(this.timer)
          this.classStatus = "unlineSelect";//断开连接
          this.socketstateLine('1')
        }
      }
    },
    loginKefu(){
      this.socketInit()
          .then(data => {
            this.onMessage()
            // this.socketHeart()//心跳
            //建立连接
            this.$message.success("上线成功");
            this.lineStatus = "在线";
            this.editorShow("", true, "#000");
            this.classStatus = "onlineSelect";
            this.serviceNickName({name:this.username,type:'sNickName'});
            this.socketstateLine('0')
          })
          .catch(result => {
            this.$message.error("连接失败!");
            this.lineStatus = "离线";
            this.classStatus = "unlineSelect";
            this.canHeart=false
            clearInterval(this.timer);
          });
    },
    getDomContent(){
      //解析输入框文本
        this.content=[]
        let arr=[]
        let html=$('.w-e-text-container').children().html().replace(/<br>/g, '').replace(/\s+/g, "").replace(/<([\/]?)(div)((:?\s*)(:?[^>]*)(:?\s*))>/g,'')
        console.log(html)
        let trueHtml=html.indexOf('<p')!==-1?html.substring(html.indexOf('<p>')+3,html.indexOf('</p>')):html
        if(trueHtml.indexOf('img')!==-1){
          //有图片
          let imgReg = /<img.*?(?:>|\/>)/gi;
          arr = trueHtml.match(imgReg);
          let reg = new RegExp("(<)|(>)","g");
          trueHtml = trueHtml.replace(reg,"\n");
          arr = trueHtml.split("\n")
          //匹配src属性
          let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          arr.forEach((item,index)=>{
            let src=item.match(srcReg)
            if(src&&src[1]){
              item=src[1]
            }
            if(item){
              this.content.push(item)
            }
          })
        }else{
          this.content.push($('.w-e-text-container').text())
        }
    },
    //发送
    async sendCustomMessage() {
      this.getDomContent()
      if(this.content.length===0){
        this.$message.error("不能发送空白信息");
        this.editor.txt.clear();
        return false;
      }
      this.content.forEach((item,index)=>{
        if(item){
          if(item.indexOf('http')===-1){
                //文本
             let data = {
              touser: this.userOpenId,
              msgtype: "text",
              text: {
                content: item,
              },
              serviceId: this.username
            };
             this.httpsendCustomMessage(data,true)
          }else{
              //图片
            let data={
                "touser":this.userOpenId,
                "msgtype":"image",
                "image": {
                  "media_id":this.media_id[item]
                },
                'url':item,
                'serviceId': this.username
              }
              this.httpsendCustomMessage(data,true)
          }
           this.socketSend({ message: item });
        }
      })
      this.updateChatList({message:this.content[this.content.length-1],openid:this.userOpenId})
      this.editor.txt.clear();
      this.scrollBottom()
    },
    async httpsendCustomMessage(data,clear){
       let res=await axios({
        method: "post",
        url: `hcm/weChat/sendCustomMessage`,
        headers: {
          "Content-type": "application/json;charset=UTF-8"
        },
        data
      })
      if (res.data.status !== "10000") {
         this.$message.error("消息发送失败");
      }
      if(clear)this.editor.txt.clear();
    },
    async firstService() {
      if(!$('.w-e-text-container').children().text()&&$('.w-e-text-container').children().html().indexOf('img')===-1){
         this.$message.error('不能发送空白消息');
        return false
      }
      if(!this.userOpenId||this.userData.stateLine==='1'){
          this.$message.error('不能发送消息');
          return false
      }
      if(this.firstServiceData!==1){
        let result = await fetchGet(`/hcm/weChat/firstService`, {
        openid: this.userOpenId,
        serviceName: this.username,
        serviceNickname:this.sNickName
        });
      if (result.data === 0) {
         let data = {
              touser: this.userOpenId,
              msgtype: "text",
              text: {
                content: `${this.sNickName}为您服务`
              },
              serviceId: this.username
            };
          await this.httpsendCustomMessage(data);
       }
        this.firstServiceData=result.data
      }
       this.sendCustomMessage()
    },
    saveVal(val){
      this.saveValId=val
      console.log(this.saveValId)
    },
    //转接
    async totoUserName(){
      if(this.saveValId){
       let message
       let arr=JSON.parse(JSON.stringify(this.allMsg)).reverse()
        for(let index in arr){
          if(arr[index].type===0&&arr[index].messageid!=='system'){
            message=arr[index].message
            break
          }
        }
        let params={
            toUserName:this.saveValId,
            fromUserName:this.username,
            message:message||'',
            openid:this.userOpenId,
            megid:this.userData.megid
          }
          await axios({
            method: "get",
            url: `/hcm/websocket/forward`,
            params
          })
          this.$message.success('转接成功');
          this.serviceNickName({name:this.checkKEFU}).then(res=>{
             this.saveSystemMessage(`会话由  ${this.sNickName}  转接至  ${res}`)
          })
          let clientList=localStorage.getItem('clientList')
          if(clientList){
            let clineArr=clientList.split(',')
            clineArr.forEach((item,index)=>{
              if(item===this.userOpenId){
                clineArr.splice(index,1)
                localStorage.setItem('clientList',clineArr)
              }
            })
          }
          this.returnShow=false;
          await this.socketOpen()
          if(this.userList.length>0) {
              this.$emit('toChatThis')
          }else{
             this.changeOpenId({openid:'',nickname:'',headimgurl:''})
             this.clearallMsg()
          }
          this.checkKEFU=''
      }
   },
   saveSystemMessage(msg){
      fetchGet(`/hcm/weChat/saveSystemMessage`,{openid:this.userOpenId,servcieName:this.checkKEFU,message:msg})
   },
   timeDiff(index){
      let stime =new Date(this.allMsg[index].createtime).getTime()
      if(index>0){
        let etime = new Date(this.allMsg[index-1].createtime).getTime();
         var usedTime =  stime - etime;  //两个时间戳相差的毫秒数
        var days=Math.floor(usedTime/(24*3600*1000));
        //计算出小时数
        var leave1=usedTime%(24*3600*1000);    //计算天数后剩余的毫秒数
        var hours=Math.floor(leave1/(3600*1000));
        //计算相差分钟数
        var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
        var minutes=Math.floor(leave2/(60*1000));
        return minutes
      }
      else if(index===0){return 11}
    }
  },

};
</script>
<style lang="scss">
#wechatMain {
  ._v-container[data-v-ecaca2b0] {
    top: 55px;
  }
  ._v-container {
    height: 50% !important;
    overflow: auto;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;
    margin-top: 20px;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .w-e-toolbar {
    background: #f6f6f6 !important;
    border: none !important;
    border-top: 1px solid #dddddd !important;
  }
  .w-e-toolbar div {
    display: none;
  }
  .w-e-toolbar div:nth-child(15) {
    display: block !important;
  }
  .w-e-text-container {
    height: 80% !important;
    border: none !important;
    z-index: 2000 !important;
  }
  .w-e-icon-image {
    font-size: 17px !important;
  }
  .w-e-toolbar .w-e-menu i {
    color: #444 !important;
  }
  .el-button.is-round {
    padding: 8px 23px;
  }
  .w-e-text {
    padding: 0 20px;
  }
  position: relative;
  box-sizing: border-box;
  height: calc(100% - 160px);
  .chatEnd {
    font-size: 12px;
    background: #dfdede;
    text-align: center;
    border: 1px solid #b2b3b3;
    clear: both;
    height: 24px;
    line-height: 24px;
    left: calc((100% - 274px) / 2);
    margin: auto;
    display: inline-block;
    padding: 2px 5px;
  }
  .wechatHeader {
    display: flex;
    justify-content: space-between;
    div:last-child {
      color: #108cee;
      span {
        cursor: pointer;
        display: inline-block;
        margin-left: 20px;
      }
    }
  }
  .content {
    .chatInfo {
      clear: both;
      margin-bottom: 34px;
    }
    height: 380px;
    background: #f6f6f6;
    padding: 20px;
    height: 50%;
    .profilePhoto {
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    .bubble {
      min-height: 32px;
      border-radius: 16px;
      padding: 0 20px;
      line-height: 32px;
      max-width: 300px;
      word-wrap: break-word;
    }
    .bubbleWhite {
      background: #fff;
      margin-left: 10px;
    }
    .bubbleBlue {
      background: #d0e7fc;
      margin-right: 10px;
    }
  }
  .bootomSend {
    position: relative;
    border-top: 1px solid #dddddd;
    height: 60%;
    .el-button {
      margin-right: 20px;
    }
    .toolFix {
      display: flex;
      justify-content: space-between;
      position: absolute;
      align-items: center;
      left: 47px;
      width: 94%;
      top: 2px;
      .el-select .el-input__inner {
        border: none;
        background: #f6f6f6;
        width: 70px;
        padding-left: 5px;
      }
      .iconTool {
        font-size: 20px;
        margin-right: 15px;
        cursor: pointer;
      }
    }
    .el-textarea {
      height: 80%;
    }
    .el-textarea__inner {
      background: #f6f6f6;
      height: 100%;
      border: none;
    }
  }
}
.unline span,
.unlineSelect .el-input,
.unlineKefu {
  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #cdcdcd;
  }
}
.online span,
.onlineSelect .el-input,
.onlineKefu {
  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #52c41a;
  }
}
.chekKefu {
  height: 200px;
}
.el-scrollbar__wrap li {
  display: flex;
  justify-content: space-between;
}
</style>
